var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionComments',{attrs:{"id":_vm.id,"entity":_vm.entity,"title":_vm.$t('pages.event-view.comments')}})}
var staticRenderFns = []

export { render, staticRenderFns }